import { getOr } from 'lodash/fp';
import { createSelector } from 'reselect';
import { composeProps, createPropsExtender } from '@mews/framework';
import { utcToLocalizedDateTime } from '@mews-commander/utils';
import { pickEntityMeta } from '../ducks/utils';
import { getProfileName as getRegularProfileName } from '../ducks/profiles';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from './session/enterprise';

const getEntityMeta = (getEntity: $TSFixMe) =>
    createSelector(getEntity, (entity: $TSFixMe) => (entity != null ? pickEntityMeta(entity) : null));

const getActorProfileId = (getEntity: $TSFixMe, actor: $TSFixMe) =>
    createSelector(getEntityMeta(getEntity), getOr(null, actor));

const getCreatorName = (getEntity: $TSFixMe, getProfileName: $TSFixMe) =>
    composeProps(getProfileName, createPropsExtender('id', getActorProfileId(getEntity, 'creatorProfileId')));

const getUpdaterName = (getEntity: $TSFixMe, getProfileName: $TSFixMe) =>
    composeProps(getProfileName, createPropsExtender('id', getActorProfileId(getEntity, 'updaterProfileId')));

export const createEntityFormattedMetaSelector = (getEntity: $TSFixMe, getProfileName = getRegularProfileName) =>
    createSelector(
        getEntityMeta(getEntity),
        getCreatorName(getEntity, getProfileName),
        getUpdaterName(getEntity, getProfileName),
        getCurrentEnterpriseIanaTimeZoneIdentifier,
        (entityMeta, creatorName, updaterName, timezone) => ({
            creatorName,
            updaterName,
            createdDateTime: entityMeta?.createdUtc && utcToLocalizedDateTime(entityMeta.createdUtc, timezone),
            updatedDateTime: entityMeta?.createdUtc && utcToLocalizedDateTime(entityMeta.updatedUtc, timezone),
        })
    );
